<template>
	<div class="image_box">
		<img style="max-width:100%;max-height:400rpx; block;margin:0 auto;" :src="url" @click="imgClick">
	</div>
</template>

<script>
	export default {
		data(){
			return {
				
			}
		},
		props:{
			url:{
				type:String,
				default:''
			}
		},
		mounted() {
			console.log(this.url)
		},
		methods:{
			imgClick(e){
		
			},
			
			// 预览图片
			watchImg: function(e) {
			
			},
		}
	}
</script>

<style scoped lang="scss">
	/* 图片题 */
	.image_box {
		height: 400px;
		margin: 40px auto;
		text-align: center;
		// width: 90%;
		box-sizing: border-box;
	}
</style>
